import { render, staticRenderFns } from "./SynthesisIcon.vue?vue&type=template&id=12de1f10&scoped=true&"
import script from "./SynthesisIcon.vue?vue&type=script&lang=js&"
export * from "./SynthesisIcon.vue?vue&type=script&lang=js&"
import style0 from "./SynthesisIcon.vue?vue&type=style&index=0&id=12de1f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de1f10",
  null
  
)

export default component.exports